/** Document validuntil urgency (matches backend document_expiry.py). */

export const DOCUMENT_EXPIRY_WARNING_DAYS = 30;
export const DOCUMENT_EXPIRY_CRITICAL_DAYS = 7;

export function daysUntilExpiry(validuntil) {
  if (!validuntil) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const end = new Date(validuntil);
  end.setHours(0, 0, 0, 0);
  return Math.round((end - today) / (24 * 60 * 60 * 1000));
}

/** @returns {null | 'warning' | 'critical'} */
export function documentExpiryUrgency(validuntil) {
  const days = daysUntilExpiry(validuntil);
  if (days === null || days < 0) return null;
  if (days <= DOCUMENT_EXPIRY_CRITICAL_DAYS) return "critical";
  if (days <= DOCUMENT_EXPIRY_WARNING_DAYS) return "warning";
  return null;
}

export function documentExpiryColor(validuntil) {
  const urgency = documentExpiryUrgency(validuntil);
  if (urgency === "critical") return "#c0392b";
  if (urgency === "warning") return "#e67e22";
  return undefined;
}

export function documentExpiryRowStyle(validuntil) {
  const urgency = documentExpiryUrgency(validuntil);
  if (urgency === "critical") {
    return { borderLeft: "4px solid #c0392b", backgroundColor: "rgba(192, 57, 43, 0.08)" };
  }
  if (urgency === "warning") {
    return { borderLeft: "4px solid #e67e22", backgroundColor: "rgba(230, 126, 34, 0.08)" };
  }
  return {};
}

export function formatValidUntilWithUrgency(validuntil, formatDisplayDate) {
  if (!validuntil) return "—";
  const text = formatDisplayDate(validuntil);
  const days = daysUntilExpiry(validuntil);
  if (days === null || days < 0) return text;
  if (days <= DOCUMENT_EXPIRY_CRITICAL_DAYS) {
    return `${text} (${days}d — expires soon)`;
  }
  if (days <= DOCUMENT_EXPIRY_WARNING_DAYS) {
    return `${text} (${days}d)`;
  }
  return text;
}
